/**
 * @generated SignedSource<<098c4509145cd41687aeaf7c65aaa235>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type productListConnectModelMutation$variables = {
  id: string;
  replaceStandalone: boolean;
  target: ModelDuplicateTargetInput;
};
export type productListConnectModelMutation$data = {
  readonly connectModel: string;
};
export type productListConnectModelMutation = {
  response: productListConnectModelMutation$data;
  variables: productListConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "replaceStandalone"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "target"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "replaceStandalone",
        "variableName": "replaceStandalone"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productListConnectModelMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "productListConnectModelMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "c0e5eabb5c98a9b1b0180afe356ecb4a",
    "id": null,
    "metadata": {},
    "name": "productListConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation productListConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n  $replaceStandalone: Boolean!\n) {\n  connectModel(id: $id, target: $target, replaceStandalone: $replaceStandalone)\n}\n"
  }
};
})();

(node as any).hash = "27e48453475f0ffd3327216abe1443d3";

export default node;
